import { render, staticRenderFns } from "./TagConfirm.vue?vue&type=template&id=24c8328c"
import script from "./TagConfirm.vue?vue&type=script&lang=js"
export * from "./TagConfirm.vue?vue&type=script&lang=js"
import style0 from "./TagConfirm.vue?vue&type=style&index=0&id=24c8328c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports